/**
 * Formats a date to M/d/yyyy (no leading zeros). Backend booking endpoints
 * expect this exact shape — toLocaleDateString output is locale/browser
 * dependent, so we build it ourselves.
 */
export function formatMDY(date: Date): string {
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
}

/**
 * Coerces unknown form values into a Date. Form controls populated by
 * patchValue from a JSON response hold ISO strings, not Date instances.
 */
export function toDate(value: unknown): Date | null {
    if (value == null || value === '') return null;
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
    if (typeof value === 'string' || typeof value === 'number') {
        const d = new Date(value);
        return Number.isNaN(d.getTime()) ? null : d;
    }
    return null;
}

/**
 * Formats a date to M/d/yyyy h:mm tt format
 * Example: 1/15/2025 3:45 PM
 */
export function formatDate(date: Date): string {
    const month = date.getMonth() + 1; // getMonth() is zero-based
    const day = date.getDate();
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";

    // Convert to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    // Pad minutes with leading zero if needed
    const minutesStr = minutes < 10 ? "0" + minutes : minutes.toString();

    return `${month}/${day}/${year} ${hours}:${minutesStr} ${ampm}`;
}

export function getCurrentTimeZoneOffsetHours(date: Date): number {
  // 1. Get raw minutes (JS returns positive for 'behind UTC', e.g. 300 for EST)
  const rawMinutes = date.getTimezoneOffset();

  // 2. Invert sign to match ISO standard (West = Negative)
  const isoMinutes = rawMinutes * -1;

  // 3. Convert to hours
  return isoMinutes / 60;
}